module.exports = __webpack_public_path__ + "static/img/color-palette-1.54d78fd9.svg";